export enum ECommissionIncludeType {
    ORDER = 1,
    STAGE = 2
}

export enum ECommissionCalcBasis {
    GROSS_VALUE = 1,
    NET_VALUE = 2
}

export enum ECommissionKey {
    ORDER_FINISH = 1,
    ORDER_REOPEN = 2,
    CHANGE_EMPLOYEE = 3,
    CHANGE_VALUE = 4
}
